// extracted by mini-css-extract-plugin
export default {"costModifierBlock":"cost-modifer-per-units-feauter_costModifierBlock__fdFc0","colons":"cost-modifer-per-units-feauter_colons__j07y9"};